import { push } from "react-router-redux"
import { put, takeEvery } from "redux-saga/effects"
import { removeCase } from "./actions"
import { DAMAGE_CASE_DISCARD_CASE } from "./constants"

export function discardCase(caseId) {
  return {
    type: DAMAGE_CASE_DISCARD_CASE,
    data: { caseId },
  }
}

// worker Saga: will be fired on DAMAGE_CASE_DISCARD_CASE actions
export function* doDiscardCase({ data: { caseId } }) {
  yield put(removeCase(caseId))
  yield put(push("/"))
}

export function* watchDiscardCase() {
  yield takeEvery(DAMAGE_CASE_DISCARD_CASE, doDiscardCase)
}

// This action has no reducer. It exists solely to wrap other actions in a sequence.



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/discardCase.js